export default
  [
    {
      path: '',
      redirect: 'salesManagement'
    },
    // 销售管理
    {
      path: 'salesManagement',
      name: '/marketingCenter/salesManagement',
      component: () => import('@/page/marketingCenter/salesManagement'),
      meta: { openKeyName: '销售及业绩管理', selectKeyUrl: 'salesManagement' }
    },
    // 出差及来访计划
    {
      path: 'businessTripAndVisitPlan',
      name: '/marketingCenter/businessTripAndVisitPlan',
      component: () => import('@/page/marketingCenter/businessTripAndVisitPlan'),
      meta: { openKeyName: '销售及业绩管理', selectKeyUrl: 'businessTripAndVisitPlan' }
    },
    // 业绩统计表
    {
      path: 'performanceStatistics',
      name: '/marketingCenter/performanceStatistics',
      component: () => import('@/page/marketingCenter/performanceStatistics'),
      meta: { openKeyName: '销售及业绩管理', selectKeyUrl: 'performanceStatistics' }
    },
    // 潜在客户管理
    {
      path: 'leadManagement',
      name: '/marketingCenter/leadManagement',
      component: () => import('@/page/marketingCenter/leadManagement'),
      meta: { openKeyName: '商机管理', selectKeyUrl: 'leadManagement' },
      props: true
    },
    {
      path: 'leadManagement/:id',
      name: '/marketingCenter/leadManagement/detail',
      component: () => import('@/page/marketingCenter/leadManagementDetail'),
      meta: { openKeyName: '商机管理', selectKeyUrl: 'leadManagement' },
      props: true
    },
    // 公海客户
    {
      path: 'highSeasCustomers',
      name: '/marketingCenter/highSeasCustomers',
      component: () => import('@/page/marketingCenter/highSeasCustomers'),
      meta: { openKeyName: '商机管理', selectKeyUrl: 'highSeasCustomers' }
    },
    {
      path: 'highSeasCustomers/:id',
      name: '/marketingCenter/highSeasCustomers/detail',
      component: () => import('@/page/marketingCenter/highSeasCustomersDetail'),
      meta: { openKeyName: '商机管理', selectKeyUrl: 'highSeasCustomers' },
      props: true
    },
  ]



// WEBPACK FOOTER //
// ./src/router/marketingCenter/index.js